// Initialize MegaFlyout
(function () {
    $('.closeFlyout').click(function (e) {
        $('.megaflyout').fadeOut(200);
    });

    var hoverFlyoutConfig = {
        over: function () {
            $(this).find(".megaflyout").fadeIn(200);
        },
        timeout: 500,
        out: function () {
            $(this).find(".megaflyout").fadeOut(200);
        }
    };

    $("#adminnavbtn").hoverIntent(hoverFlyoutConfig);
    $("header nav >ul >li, .mainnav li").hoverIntent(hoverFlyoutConfig);
    $(".badges li").hoverIntent(hoverFlyoutConfig);
    $("#newsletter").hoverIntent(hoverFlyoutConfig);
})();